// Token generation constants
const OAuthTokenGenerationConstants = Object.freeze({
    OPENID_SCOPE: 'All:BrokerPortalUser All:IVRUser EIS:SystemUser Read:ClaimSet',
    RESPONSE_TYPE: 'code',
    RESPONSE_MODE: 'web_message',
    PROMPT: 'none',
    CODE_CHALLENGE_METHOD: 'S256',
    GRANT_TYPE: 'authorization_code'
});

module.exports = {
    OAuthTokenGenerationConstants
};
